import DevExpressDataGrid from 'components/inheritComponent/devexpressdatagrid'
import React, { Component } from 'react'
import { addURL } from 'redux/actions/url'
import KlaimApproval from './modalApproval/index'

class PengajuanKlaimPesertaAktif extends Component {
  constructor(props) {
    super(props)

    this.dataGridRef = React.createRef()
    this.ApproveKlaimRef = React.createRef()
    this.RejectedKlaimRef = React.createRef()

    this.participantId = this.props.store.getState().sessionUser
      ? this.props.store.getState().sessionUser.participantId
      : 0
    this.userLoged = this.props.store.getState().sessionUser
      ? this.props.store.getState().sessionUser.username
      : ''

    this.columns = [
      {
        type: 'buttons',
        buttons: [
          'edit',
          {
            text: 'Setuju',
            hint: 'edit',
            onClick: (e) => {
              this.ApproveKlaimRef.current.show(e.row.key)
            },
          },
          {
            text: 'Tolak',
            hint: 'edit',
            onClick: (e) => {
              this.RejectedKlaimRef.current.show(e.row.key)
            },
          },
        ],
      },
      {
        dataField: 'nik',
        caption: 'NIK',
      },
      {
        dataField: 'fullName',
        caption: 'Nama Karyawan',
      },
      {
        dataField: 'productName',
        caption: 'Produk Dana Pensiun',
      },
      {
        dataField: 'klaimDate',
        caption: 'Tanggal Klaim',
        dataType: 'date',
        format: 'dd MMM yyyy',
      },
      {
        dataField: 'klaimName',
        caption: 'Jenis Klaim',
      },
      {
        dataField: 'entryTipe',
        caption: 'Input Oleh',
      },
      {
        dataField: 'nilaiKlaim',
        caption: 'Nilai Klaim',
        alignment: 'center',
        columns: [
          {
            dataField: 'unitTransaksi',
            caption: 'Unit Transaksi',
            dataType: 'number',
            format: '#,##0.00',
            alignment: 'right',
          },
          {
            dataField: 'klaimPersen',
            caption: 'Persen',
            dataType: 'number',
            format: '#,##0.00',
            alignment: 'right',
          },
          {
            dataField: 'klaimNominal',
            caption: 'Nominal',
            dataType: 'number',
            format: '#,##0.00',
            alignment: 'right',
          },
          {
            dataField: 'klaimValueTipe',
            caption: 'Nett / Bruto',
          },
        ],
      },
      {
        dataField: 'statusName',
        caption: 'Status',
      },
    ]
  }

  componentWillMount() {
    let store = this.props.store
    store.dispatch(addURL(this.props.location.pathname))
  }

  forceRefresh = () => {
    this.dataGridRef.current.forceRefresh(true)
  }

  render() {
    return (
      <>
        <div className="container-fluid">
          <h2 className="main-title">Persetujuan Klaim Online</h2>

          <DevExpressDataGrid
            ref={this.dataGridRef}
            loadAPI={`wp/claim-list?klaimStatusId.equals=30&participantId.equals=${this.participantId}`}
            insertAPI="-"
            updateAPI="-"
            deleteAPI="-"
            backendserver={process.env.REACT_APP_BACKEND_CORE}
            remoteOperations={true}
            allowAdding={false}
            allowDeleting={false}
            allowUpdating={false}
            exportExcel={false}
            exportFileName={'Persetujuan Klaim Online'}
            allowExportSelectedData={true}
            selection={'multiple'}
            showBorders={true}
            paging={true}
            defaultPageSize={10}
            height={'80vh'}
            popupTitle={'Persetujuan Klaim Online'}
            popupWidth={700}
            popupHeight={500}
            popupFormLabelLocation="left"
            popupFormMinColWidth={300}
            popupFormColCount={3}
            ColumnChooser={true}
            ColumnFixing={true}
            FilterRow={true}
            ColumnConfiguration={this.columns}
            store={this.props.store}
          />
        </div>

        <KlaimApproval
          store={this.props.store}
          type="approve"
          ref={this.ApproveKlaimRef}
          forceRefresh={this.forceRefresh}
        />
        <KlaimApproval
          store={this.props.store}
          type="rejected"
          ref={this.RejectedKlaimRef}
          forceRefresh={this.forceRefresh}
        />
      </>
    )
  }
}

export default PengajuanKlaimPesertaAktif
